module.exports = __webpack_public_path__ + "media/img/arrow-down-icon-04f3dad793fdfba271b88e0e6f08096f.png";